import React from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import _ from "lodash";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

class DisableConnectorDialog extends React.Component {
  render() {
    return (
      <Dialog open={this.props.open} onClose={() => {}} aria-labelledby="draggable-dialog-title">
        <DialogTitle id="draggable-dialog-title">Disable Connector</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to disable{" "}
            <b>
              {" "}
              {_.get(
                this.props,
                "currentConnection.display_name",
                _.get(this.props, "currentConnection.connectorName", "")
              )}{" "}
            </b>{" "}
            connector?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.props.closeDisableConnectorDialog();
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              this.props.confirmDisableConnectorDialog();
            }}
            color="primary"
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default DisableConnectorDialog;
